import { createListenerMiddleware, createSlice } from "@reduxjs/toolkit"
import { useCallback, useEffect, useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { subscribe } from "lib/live_events"
import { omit } from "lodash"

import { monitoringState, useMonitoredState, forHeartbeat } from "../utils"

const { initialState, actions } = monitoringState()
const reducers = { ...actions }

const slice = createSlice({
  name: 'messages',
  initialState, reducers
})

export function useMessages(ids) {
  return useMonitoredState('messages', slice.actions, ids)
}

export function useMessage(id) {
  const { messages, allLoaded: loaded } = useMessages([id])
  return { message: messages[0], loaded }
}

// External event hookup
export function registerListeners(listenerMiddleware, initAction) {
  listenerMiddleware.startListening({
    actionCreator: initAction,
    effect: async (action, {dispatch}) => {
      subscribe('messaging.new_comment', comment => {
        const data = { 
          [comment.id]: omit(comment, ['owner_user']) 
        }

        dispatch(slice.actions.addData(data))
      })
    },
  });
}


export const heartbeatActions = forHeartbeat(slice.actions)
export default slice.reducer